import { Component, Input } from "@angular/core";
import { BusinessPorting } from "src/app/meta/BusinessPorting.interface";

@Component({
    selector: "ow-order-summary-business-porting",
    templateUrl: "./order-summary-business-porting.component.html"
})
export class OrderSummaryBusinessPortingComponent {

    @Input() businessPorting!: BusinessPorting
    @Input() portingNumbers!: string

}
